(function () {
  'use strict';

  function cartTarget() {
    return window.innerWidth <= 768
      ? document.querySelector('.genz-nav-item--cart .genz-nav-icon-wrapper')
      : document.querySelector('.header__cart-btn');
  }

  function flyToCart(image) {
    var target = cartTarget();
    if (!image || !target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var from = image.getBoundingClientRect();
    var to = target.getBoundingClientRect();
    if (!from.width || !from.height) return;
    var flyer = image.cloneNode(true);
    flyer.className = 'fly-to-cart-element';
    Object.assign(flyer.style, { top: from.top + 'px', left: from.left + 'px', width: from.width + 'px', height: from.height + 'px' });
    document.body.appendChild(flyer);
    flyer.getBoundingClientRect();
    flyer.style.transform = 'translate(' + (to.left + to.width / 2 - from.left - from.width / 2) + 'px,' + (to.top + to.height / 2 - from.top - from.height / 2) + 'px) scale(.1)';
    flyer.style.opacity = '0';
    window.setTimeout(function () { flyer.remove(); }, 800);
  }

  function openCart() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.getElementById('cart-drawer-overlay');
    if (drawer) drawer.classList.add('is-active');
    if (overlay) overlay.classList.add('is-active');
    document.body.classList.add('cart-is-open');
  }

  window.refreshCartDrawer = function () {
    return fetch(window.location.pathname + '?cart_refresh=' + Date.now(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (response) { if (!response.ok) throw new Error('Unable to refresh cart'); return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.getElementById('cart-drawer');
        var current = document.getElementById('cart-drawer');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
      });
  };

  window.updateGlobalCart = function () {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (response) { if (!response.ok) throw new Error('Unable to load cart'); return response.json(); })
      .then(function (cart) {
        document.querySelectorAll('.js-cart-count-text').forEach(function (element) { element.textContent = cart.item_count; });
        return window.refreshCartDrawer();
      });
  };

  function wishlist() {
    try { return JSON.parse(localStorage.getItem('jewel_wishlist')) || []; } catch (error) { return []; }
  }

  function syncWishlist() {
    var saved = wishlist();
    document.querySelectorAll('.js-wishlist-btn').forEach(function (button) {
      var active = saved.indexOf(button.dataset.productHandle) !== -1;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  document.addEventListener('click', function (event) {
    var quantityButton = event.target.closest('.js-drawer-quantity');
    if (quantityButton) {
      event.preventDefault();
      if (quantityButton.disabled) return;
      var drawerItem = quantityButton.closest('.cart-drawer-item');
      var drawer = document.getElementById('cart-drawer');
      if (drawerItem) drawerItem.classList.add('is-updating');
      if (drawer) drawer.setAttribute('aria-busy', 'true');
      quantityButton.disabled = true;
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ line: Number(quantityButton.dataset.line), quantity: Math.max(0, Number(quantityButton.dataset.quantity)) })
      }).then(function (response) {
        return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Could not update quantity.'); return data; });
      }).then(function (cart) {
        document.querySelectorAll('.js-cart-count-text').forEach(function (element) { element.textContent = cart.item_count; });
        return window.refreshCartDrawer();
      }).then(function () {
        openCart();
      }).catch(function (error) {
        if (drawerItem) drawerItem.classList.remove('is-updating');
        quantityButton.disabled = false;
        window.alert(error.message);
      }).finally(function () {
        var currentDrawer = document.getElementById('cart-drawer');
        if (currentDrawer) currentDrawer.removeAttribute('aria-busy');
      });
      return;
    }

    var buyNowButton = event.target.closest('#MobileBuyNowBtn');
    if (buyNowButton) {
      event.preventDefault();
      if (buyNowButton.disabled || buyNowButton.classList.contains('is-loading')) return;
      var productForm = document.getElementById('ProductForm');
      if (!productForm) return;
      buyNowButton.disabled = true;
      buyNowButton.classList.add('is-loading');
      buyNowButton.setAttribute('aria-busy', 'true');
      var buyLabel = buyNowButton.querySelector('.mobile-buy-now-label');
      if (buyLabel) buyLabel.textContent = 'Preparing checkout…';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(productForm)
      }).then(function (response) {
        return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Could not start checkout.'); return data; });
      }).then(function () {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
      }).catch(function (error) {
        var message = productForm.querySelector('.product-form__message');
        if (message) message.textContent = error.message;
        buyNowButton.disabled = false;
        buyNowButton.classList.remove('is-loading');
        buyNowButton.removeAttribute('aria-busy');
        if (buyLabel) buyLabel.textContent = 'Buy now';
      });
      return;
    }

    var cardBuyNowButton = event.target.closest('.js-product-card-buy-now');
    if (cardBuyNowButton) {
      event.preventDefault();
      if (cardBuyNowButton.disabled || cardBuyNowButton.classList.contains('is-loading')) return;
      var cardForm = cardBuyNowButton.closest('form[action*="/cart/add"]');
      if (!cardForm) return;
      var cardMessage = cardForm.querySelector('.product-card__message');
      cardBuyNowButton.disabled = true;
      cardBuyNowButton.classList.add('is-loading');
      cardBuyNowButton.setAttribute('aria-busy', 'true');
      if (cardMessage) cardMessage.textContent = '';
      fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(cardForm)
      }).then(function (response) {
        return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Could not start checkout.'); return data; });
      }).then(function () {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
      }).catch(function (error) {
        if (cardMessage) cardMessage.textContent = error.message;
        else window.alert(error.message);
        cardBuyNowButton.disabled = false;
        cardBuyNowButton.classList.remove('is-loading');
        cardBuyNowButton.removeAttribute('aria-busy');
      });
      return;
    }

    var cartTrigger = event.target.closest('.js-cart-trigger, .js-cart-trigger-bottom');
    var cartClose = event.target.closest('.js-cart-close, #cart-drawer-overlay');
    if (cartTrigger) { event.preventDefault(); openCart(); }
    if (cartClose) {
      event.preventDefault();
      var drawer = document.getElementById('cart-drawer');
      var overlay = document.getElementById('cart-drawer-overlay');
      if (drawer) drawer.classList.remove('is-active');
      if (overlay) overlay.classList.remove('is-active');
      document.body.classList.remove('cart-is-open');
    }

    var wishButton = event.target.closest('.js-wishlist-btn');
    if (wishButton) {
      var saved = wishlist();
      var index = saved.indexOf(wishButton.dataset.productHandle);
      if (index === -1) saved.push(wishButton.dataset.productHandle); else saved.splice(index, 1);
      try { localStorage.setItem('jewel_wishlist', JSON.stringify(saved)); } catch (error) { /* Storage can be disabled. */ }
      syncWishlist();
    }
  });

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches('form[action*="/cart/add"], .product-form')) return;
    event.preventDefault();
    var button = event.submitter || form.querySelector('[type="submit"]');
    var isCardBuyNow = button && button.classList.contains('js-product-card-buy-now');
    var message = form.querySelector('.product-card__message, .product-form__message');
    var image = form.closest('.product-card') ? form.closest('.product-card').querySelector('.product-card__image') : document.getElementById('ProductMainImage');
    if (button) { button.disabled = true; button.classList.add('is-loading'); button.setAttribute('aria-busy', 'true'); }
    if (message) message.textContent = '';

    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form)
    }).then(function (response) {
      return response.json().then(function (data) { if (!response.ok) throw new Error(data.description || 'Could not add this item.'); return data; });
    }).then(function () {
      if (isCardBuyNow) {
        window.location.href = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'checkout';
        return;
      }
      flyToCart(image);
      if (message) message.textContent = 'Added to your bag';
      return window.updateGlobalCart();
    }).then(function () {
      if (!isCardBuyNow) openCart();
    }).catch(function (error) {
      if (message) message.textContent = error.message;
      else window.alert(error.message);
    }).finally(function () {
      if (button) { button.disabled = false; button.classList.remove('is-loading'); button.removeAttribute('aria-busy'); }
    });
  });

  document.addEventListener('DOMContentLoaded', syncWishlist);
})();
